import { render, staticRenderFns } from "./PixPaymentCard.vue?vue&type=template&id=396abc75&scoped=true"
import script from "./PixPaymentCard.vue?vue&type=script&lang=js"
export * from "./PixPaymentCard.vue?vue&type=script&lang=js"
import style0 from "./PixPaymentCard.vue?vue&type=style&index=0&id=396abc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396abc75",
  null
  
)

export default component.exports